module.exports = __webpack_public_path__ + "img/invite-banner-img.c4872021.png";